<template>
  <v-container fill-height>
    <v-layout align-center column>
      <v-card>
        <v-card-title>
          <span class="headline">Connect Google</span>
        </v-card-title>
        <v-card-text>
            <v-btn color="primary" @click="connectGoogle">
              <v-icon left>add</v-icon>
              Google
            </v-btn>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { $http } from '@/services/http-common'

export default {
  name: 'googleConnect',
  data: () => ({
    clientId: process.env.VUE_GDRIVE_CLIENT_ID
  }),
  methods: {
    connectGoogle () {
      this.$gAuth.getAuthCode().then(authCode => {
        // on success
        console.log('authCode', authCode)
        $http.post('/api/authcode', {
          code: authCode
        })
      }).then(response => {
        // after ajax
      }).catch(error => {
        // on fail do something
        console.error(error)
      })
    }
  }
}
</script>

<style>

</style>
